import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { DialogService } from '../services/dialog/dialog.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface CanComponentDeactivate {
  canDeactivate: () => boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate
): Observable<boolean> | boolean => {
  if (component.canDeactivate()) {
    return true;
  }

  return inject(DialogService).confirm({
    title: `Unsaved Changes`,
    message: `You made changes to the tenancy. Would you like to save them?`,
    actions: [
      { text: "Discard", result: true, color: null },
      { text: "Save Changes", result: false, color: "#1675C7" }
    ]
  }).pipe(
    map(result => !!result)
  );
};
